import { useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import emailjs from '@emailjs/browser';
import { setHours, setMinutes } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import './index.css';
import { generateTimeOptions } from '../../components/TimePicker/generateTimeDropdownOptions';

const servicesOptions = [
  { value: 'service1', label: 'Service 1' },
  { value: 'service2', label: 'Service 2' },
  { value: 'service3', label: 'Service 3' },
];

const nurseOptions = [
  { value: 'nurse1', label: 'Nurse 1' },
  { value: 'nurse2', label: 'Nurse 2' },
  { value: 'nurse3', label: 'Nurse 3' },
];

export const Appointment = () => {
  const formRef = useRef<HTMLFormElement | null>(null);

  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedTime, setSelectedTime] = useState<{
    value: string;
    label: string;
  } | null>(null);
  const [selectedService, setSelectedService] = useState<{
    value: string;
    label: string;
  } | null>(null);
  const [selectedNurse, setSelectedNurse] = useState<{
    value: string;
    label: string;
  } | null>(null);
  const [message, setMessage] = useState<string>('');
  const [preferredContact, setPreferredContact] = useState<{
    value: string;
    label: string;
  } | null>(null);

  const contactOptions = [
    { value: 'email', label: 'E-pasts' },
    { value: 'phone', label: 'Mobilais' },
    { value: 'both', label: 'Epasts un mobilais' },
  ];

  const timeOptions = generateTimeOptions();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // if (!formRef.current) {
    //   alert('Form is not loaded yet!');
    //   return;
    // }

    if (!selectedDate) {
      return;
    }

    // const formData = {
    //   name,
    //   email,
    //   phone,
    //   selectedDate,
    //   selectedService,
    //   selectedNurse,
    //   message,
    // };

    const formattedDate = selectedDate.toLocaleDateString('lv-LV', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const templateParams = {
      name,
      email,
      phone,
      date: formattedDate,
      message,
      preferredContact: preferredContact?.label || '',
    };

    // console.log('form - ', formData);
    // Handle form submission logic here

    emailjs
      .send(
        'service_a5mc0kf',
        'template_y24kf6g',
        templateParams,
        '9_z4XbUxbeJtHm_2S'
      )
      .then(
        (result) => {
          alert('Pieteikums izveidots!');
          console.log(result.text);
        },
        (error) => {
          alert('Kļūda veidojot pieteikumu!');
          console.error(error);
        }
      );

    // emailjs
    //   .sendForm(
    //     'service_a5mc0kf',
    //     'template_y24kf6g',
    //     formRef.current,
    //     '9_z4XbUxbeJtHm_2S'
    //   )
    //   .then(
    //     (result) => {
    //       alert('Appointment request sent!');
    //       console.log(result.text);
    //     },
    //     (error) => {
    //       alert('Failed to send. Try again.');
    //       console.error(error);
    //     }
    //   );
  };
  return (
    <div className="appointment-container">
      <div className="appointment-title">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            letterSpacing: '2.5px',
          }}
        >
          <div style={{ fontSize: '38px' }}>Pieraksties</div>
          <div>
            Strādājam katru dienu (arī nedēļas nogalē) no 8.00 līdz 20.00 tikai
            pēc iepriekšēja pieraksta.
          </div>
        </div>
      </div>

      <form ref={formRef} onSubmit={handleSubmit} className="form-container">
        <div className="form-group">
          <label htmlFor="name">Vārds *</label>
          <input
            name="name"
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Telefons *</label>
          <input
            name="phone"
            type="tel"
            id="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">E-pasts</label>
          <input
            name="email"
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        {/* <div className="form-group">
          <label htmlFor="date">Pieraksta datums *</label>
          <DatePicker
            name="date"
            id="date"
            dateFormat="dd.MM.yyyy"
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            minDate={new Date()}
            required
          />
        </div> */}

        <div className="form-group">
          <label htmlFor="date">Pieraksta datums *</label>
          <DatePicker
            name="date"
            id="date"
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="dd.MM.yyyy"
            minDate={new Date()}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="time">Vēlamais pieraksta laiks *</label>
          <Select
            id="time"
            options={timeOptions}
            value={selectedTime}
            onChange={(option) => setSelectedTime(option)}
            placeholder="Izvēlies laiku"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="preferredContact">Ērtākais saziņas veids *</label>
          <Select
            id="preferredContact"
            options={contactOptions}
            value={preferredContact}
            onChange={(option) => setPreferredContact(option)}
            required
          />
        </div>

        {/* <div className="form-group">
          <label htmlFor="service">Service *</label>
          <Select
            id="service"
            options={servicesOptions}
            value={selectedService}
            onChange={(option) => setSelectedService(option)}
            required
          />
        </div> */}

        {/* <div className="form-group">
          <label htmlFor="nurse">Nurse *</label>
          <Select
            id="nurse"
            options={nurseOptions}
            value={selectedNurse}
            onChange={(option) => setSelectedNurse(option)}
            required
          />
        </div> */}

        <div className="form-group">
          <label htmlFor="message">Komentārs (speciālists, laiks utml.)</label>
          <textarea
            id="message"
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
        </div>

        <div style={{ justifyContent: 'center', display: 'flex' }}>
          <button type="submit" className="submit-button">
            Apstiprināt
          </button>
        </div>
      </form>
    </div>
  );
};
